// Centralized coordinates configuration for all regions
// This makes it easy to add, modify, and maintain region coordinates

export const regionCoordinates = {
  // France
  'bordeaux': { x: 30, y: 72, lat: 44.8, lng: -0.6 },
  'bourgogne': { x: 45, y: 45, lat: 47.0, lng: 4.8 },
  'champagne': { x: 40, y: 25, lat: 49.0, lng: 4.0 },
  'loire': { x: 30, y: 55, lat: 47.5, lng: 0.5 },
  'rhone': { x: 42, y: 48, lat: 44.8, lng: 4.8 },
  'provence': { x: 65, y: 75, lat: 43.6, lng: 5.5 },
  'languedoc-roussillon': { x: 50, y: 80, lat: 43.5, lng: 3.0 },
  'alsace': { x: 50, y: 35, lat: 48.5, lng: 7.5 },
  'jura': { x: 55, y: 40, lat: 46.8, lng: 5.8 },
  'sud-ouest': { x: 35, y: 70, lat: 44.0, lng: 0.5 },
  
  // Spain
  'rioja': { x: 35, y: 45, lat: 42.5, lng: -2.5 },
  'ribera-del-duero': { x: 30, y: 50, lat: 41.8, lng: -3.7 },
  'navarra': { x: 40, y: 45, lat: 42.8, lng: -1.6 },
  'priorat': { x: 45, y: 60, lat: 41.2, lng: 0.8 },
  'rueda': { x: 30, y: 55, lat: 41.4, lng: -4.7 },
  'rias-baixas': { x: 25, y: 70, lat: 42.5, lng: -8.8 },
  'cava': { x: 45, y: 55, lat: 41.4, lng: 1.9 },
  'jerez': { x: 35, y: 75, lat: 36.7, lng: -6.1 },
  
  // Italy
  'toscane': { x: 45, y: 55, lat: 43.5, lng: 11.0 },
  'piemont': { x: 40, y: 45, lat: 44.8, lng: 7.7 },
  'venetie': { x: 55, y: 50, lat: 45.4, lng: 12.3 },
  'sicile': { x: 50, y: 80, lat: 37.5, lng: 14.0 },
  'lombardie': { x: 45, y: 40, lat: 45.5, lng: 9.2 },
  'emilie-romagne': { x: 50, y: 45, lat: 44.5, lng: 11.0 },
  'pouilles': { x: 60, y: 70, lat: 41.0, lng: 16.9 },
  'trentin-haut-adige': { x: 50, y: 35, lat: 46.1, lng: 11.1 },
  'frioul-venetie-julienne': { x: 60, y: 45, lat: 46.1, lng: 13.2 },
  'abruzzes': { x: 55, y: 60, lat: 42.4, lng: 13.6 },
  'marches': { x: 55, y: 55, lat: 43.6, lng: 13.5 },
  'campanie': { x: 55, y: 65, lat: 40.8, lng: 14.2 },
  'supertuscan': { x: 45, y: 55, lat: 43.5, lng: 11.0 },
  
  // Portugal
  'douro': { x: 30, y: 45, lat: 41.2, lng: -7.6 },
  'alentejo': { x: 25, y: 60, lat: 38.5, lng: -7.9 },
  'dao': { x: 35, y: 45, lat: 40.6, lng: -7.9 },
  'vinho-verde': { x: 25, y: 35, lat: 41.5, lng: -8.6 },
  'bairrada': { x: 30, y: 40, lat: 40.4, lng: -8.6 },
  'lisboa': { x: 25, y: 30, lat: 39.0, lng: -9.0 },
  'setubal': { x: 25, y: 65, lat: 38.5, lng: -8.9 },
  'madeira': { x: 20, y: 80, lat: 32.7, lng: -16.9 },
  
  // Argentina
  'mendoza': { x: 35, y: 75, lat: -32.9, lng: -68.8 },
  
  // Australia
  'barossa-valley': { x: 45, y: 75, lat: -34.5, lng: 138.9 },
  'hunter-valley': { x: 55, y: 65, lat: -32.8, lng: 151.3 },
  'margaret-river': { x: 25, y: 85, lat: -33.9, lng: 115.1 },
  'mclaren-vale': { x: 40, y: 80, lat: -35.2, lng: 138.5 },
  'yarra-valley': { x: 65, y: 70, lat: -37.7, lng: 145.4 },
  'clare-valley': { x: 50, y: 70, lat: -33.8, lng: 138.6 },
  'coonawarra': { x: 35, y: 85, lat: -37.3, lng: 140.8 },
  'adelaide-hills': { x: 45, y: 70, lat: -34.9, lng: 138.7 },
  'mornington-peninsula': { x: 70, y: 75, lat: -38.3, lng: 145.0 },
  'tasmanie': { x: 60, y: 95, lat: -42.0, lng: 147.0 },
  'south-eastern-australia': { x: 50, y: 75, lat: -36.0, lng: 145.0 },
  'autres-australie': { x: 50, y: 75, lat: -36.0, lng: 145.0 },
  
  // New Zealand
  'marlborough': { x: 55, y: 65, lat: -41.5, lng: 173.5 },
  'hawkes-bay': { x: 50, y: 70, lat: -39.5, lng: 176.9 },
  'central-otago': { x: 45, y: 75, lat: -45.0, lng: 169.4 },
  'wairarapa': { x: 50, y: 75, lat: -41.0, lng: 175.5 },
  'canterbury': { x: 45, y: 80, lat: -43.5, lng: 172.6 },
  'nelson': { x: 50, y: 70, lat: -41.3, lng: 173.2 },
  
  // Austria
  'niederoesterreich': { x: 55, y: 45, lat: 48.3, lng: 16.4 },
  'burgenland': { x: 60, y: 50, lat: 47.8, lng: 16.6 },
  'steiermark': { x: 55, y: 55, lat: 47.1, lng: 15.4 },
  'wien': { x: 55, y: 45, lat: 48.2, lng: 16.4 },
  
  // Greece
  'crete': { x: 55, y: 75, lat: 35.2, lng: 24.8 },
  'macedonia': { x: 55, y: 50, lat: 41.0, lng: 21.4 },
  'peloponnese': { x: 50, y: 65, lat: 37.5, lng: 22.4 },
  
  // Chile
  'valle-del-maipo': { x: 30, y: 80, lat: -33.5, lng: -70.7 },
  'valle-del-colchagua': { x: 35, y: 75, lat: -34.7, lng: -71.2 },
  
  // Germany
  'mosel': { x: 45, y: 35, lat: 49.9, lng: 7.0 },
  'rheingau': { x: 50, y: 40, lat: 50.0, lng: 8.0 },
  'pfalz': { x: 55, y: 45, lat: 49.3, lng: 8.1 },
  
  // Switzerland
  'valais': { x: 50, y: 45, lat: 46.2, lng: 7.6 },
  'vaud': { x: 45, y: 50, lat: 46.5, lng: 6.6 },
  
  // Mexico
  'baja-california': { x: 20, y: 40, lat: 32.0, lng: -115.0 },
  'coahuila': { x: 30, y: 50, lat: 27.0, lng: -101.0 },
  'queretaro': { x: 40, y: 60, lat: 20.6, lng: -100.4 }
};

// Helper function to get coordinates for a region
export const getRegionCoordinates = (regionName) => {
  const normalizedName = regionName
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove accents
    .replace(/\s+/g, '-'); // Replace spaces with hyphens
  return regionCoordinates[normalizedName] || { x: 50, y: 50, lat: 0, lng: 0 };
};

// Helper function to get map areas for a region
export const getRegionMapAreas = (regionName, color = "#4B164C", size = 7) => {
  const coords = getRegionCoordinates(regionName);
  return [{
    region: regionName,
    x: coords.x,
    y: coords.y,
    color: color,
    size: size
  }];
}; 